import React, { useState, useEffect, useMemo } from "react";
import { Form, Input, Row, Col, FormGroup, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "components/Select";
import { getActiveColorStyle } from "utils/colorUtils";
import { getSelectStyles } from "utils/selectStyles";
import {
  getTheme2SearchFilterColProps,
  getTheme2SearchFilterMultiSelectStyles,
} from "utils/theme2MultiSelect";

const ChannelsFilters = ({
  activeColor = "secondary",
  isTheme2 = false,
  search,
  onSearchChange,
  searchType,
  onSearchTypeChange,
  statusFilter,
  onStatusFilterChange,
  typeOptions = [],
}) => {
  const { t } = useTranslation();
  const [isLightTheme, setIsLightTheme] = useState(false);
  const activeColorStyle = useMemo(
    () => getActiveColorStyle(activeColor),
    [activeColor]
  );
  const typeSelectStyles = useMemo(() => {
    if (isTheme2) {
      return getTheme2SearchFilterMultiSelectStyles(activeColorStyle, true);
    }
    return getSelectStyles(activeColorStyle, isLightTheme);
  }, [activeColorStyle, isTheme2, isLightTheme]);
  const statusOptions = useMemo(
    () => [
      { value: "active", label: t("channels.active") },
      { value: "deleted", label: t("channels.deleted") },
    ],
    [t]
  );

  useEffect(() => {
    const checkTheme = () => {
      setIsLightTheme(document.body.classList.contains("white-content"));
    };
    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  const filterColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-channels-filter-col",
    md: "4",
  });

  return (
    <Form>
      <Row className={isTheme2 ? "search-channels-filters-row" : undefined}>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("channels.search")}:</Label>
            <Input
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={t("channels.searchPlaceholder")}
              className="form-control"
            />
          </FormGroup>
        </Col>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("channels.type")}:</Label>
            <Select
              activeColor={activeColor}
              styles={typeSelectStyles}
              className="react-select"
              placeholder={t("channels.selectType")}
              name="channelTypeSelect"
              isSearchable
              closeMenuOnSelect={false}
              isMulti
              value={searchType}
              onChange={(value) => onSearchTypeChange(value || [])}
              options={typeOptions}
              isClearable
            />
          </FormGroup>
        </Col>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{t("channels.status")}:</Label>
            <Select
              activeColor={activeColor}
              styles={typeSelectStyles}
              className="react-select"
              placeholder={t("channels.selectStatus")}
              name="channelStatusSelect"
              isSearchable={false}
              closeMenuOnSelect={false}
              isMulti
              value={statusFilter}
              onChange={(value) => onStatusFilterChange(value || [statusOptions[0]])}
              options={statusOptions}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default ChannelsFilters;
